import { IDefineCommand, ICommand } from 'core-ts-types';

angular.module('capability-ng-transfer')
  .factory('loadTransferMajorRelatedCareersCommand', (
    defineCommand: IDefineCommand,
    RelatedCareersBuilder: any,
    $http: ng.IHttpService): ICommand => {
    return defineCommand('loadTransferMajorRelatedCareersCommand', function (deferred: ng.IDeferred<any>,
                                                                             majorId: string): void {
      $http({
        method: 'GET',
        url: `catalog/program/${majorId}/related-careers`
      })
      .then((response: ng.IHttpPromiseCallbackArg<any>) => {
        deferred.resolve(new RelatedCareersBuilder(response.data.results));
      })
      .catch(deferred.reject);
    });
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_major_related_careers_command.ts